{
  "zh-CN": {
    "nav": {
      "cart": "购物车",
      "locations": "地点",
      "home": "主页",
      "back": "返回",
      "navigation": "导航",
      "ships": {
        "index": "飞船"
      },
      "compare": {
        "index": "比较",
        "ships": "飞船",
        "components": "组件",
        "equipment": "装备"
      },
      "manufacturers": "制造商",
      "images": "图片",
      "videos": "视频",
      "shipHistory": "历史",
      "componentHistory": "历史",
      "hangar": {
        "index": "我的机库",
        "overview": "概览",
        "wishlist": "愿望单",
        "stats": "统计",
        "vehicleLoadouts": "Loadouts",
        "inventories": "Inventories",
        "blueprints": "蓝图",
        "assets": "资产",
        "vehicleCargo": "货物",
        "buybacks": "回购",
        "paints": "涂装",
        "flair": "机库装饰",
        "upgrades": "升级 / CCU",
        "equipment": "FPS 装备",
        "pledgeItems": "质押物品",
        "imports": "导入记录",
        "transfers": "转移",
        "vehicleOverview": "概览",
        "vehicleLog": "舰长日志",
        "shipComponents": "飞船部件",
        "plans": "规划器",
        "sharedPlan": "共享计划"
      },
      "login": "登录",
      "installApp": "安装应用",
      "logout": "登出",
      "apiV1": "API v1",
      "apiV1Schema": "架构",
      "apiV1Pagination": "分页",
      "authApiV1": "Auth API v1",
      "authApiV1OpenId": "OpenID Connect",
      "authApiV1Schema": "架构",
      "embed": "嵌入小部件",
      "signUp": "注册",
      "privacyPolicy": "隐私政策",
      "impressum": "法律声明",
      "fleets": {
        "index": "舰队",
        "add": "创建新舰队",
        "invites": "邀请",
        "ships": "飞船",
        "blueprints": "蓝图",
        "assets": "资产",
        "members": {
          "index": "Members",
          "invites": "Invites",
          "worldmap": "世界地图",
          "starmap": "星图",
          "health": "健康检查"
        },
        "squadrons": {
          "index": "中队",
          "overview": "概览",
          "members": "成员",
          "create": {
            "details": "详情",
            "appearance": "外观",
            "discord": "Discord"
          },
          "edit": {
            "details": "详情",
            "appearance": "外观",
            "discord": "Discord"
          }
        },
        "stats": "统计",
        "logistics": {
          "index": "Logistics"
        },
        "shoppingLists": "购物清单",
        "missions": {
          "index": "任务",
          "edit": {
            "details": "详情",
            "teams": "小队与席位"
          }
        },
        "events": {
          "index": "活动",
          "calendar": "日历",
          "edit": {
            "details": "详情",
            "schedule": "时间安排",
            "signup": "报名",
            "teams": "小队与席位"
          },
          "payouts": "分账"
        },
        "tours": "行程",
        "settings": {
          "index": "设置",
          "fleet": "舰队设置",
          "rsi": "舰队 ID 与 RSI",
          "membership": "成员设置",
          "roles": "角色",
          "squadrons": "中队",
          "allies": "盟友",
          "notifications": "通知",
          "discord": "Discord",
          "calendar": "日历",
          "features": "功能",
          "contracts": "合约"
        },
        "contracts": {
          "index": "合约",
          "payouts": "分账"
        },
        "directory": "目录",
        "overview": "概览"
      },
      "rsiProfile": "RSI 档案",
      "rsiHangar": "RSI 机库",
      "tools": {
        "index": "工具",
        "overview": "概览",
        "travelTimes": "旅行时间",
        "cargoGrids": "货物网格",
        "plaque": "献词铭牌",
        "tradeRoutes": "贸易路线",
        "dressingRoom": "试衣间",
        "paintBooth": "喷漆间",
        "tours": "行程"
      },
      "api": "API 文档",
      "stats": "统计",
      "toggleSlimCollapse": "折叠",
      "toggleSlimExpand": "展开",
      "roadmap": {
        "index": "路线图",
        "overview": "概览",
        "changes": "变更",
        "ships": "飞船路线图"
      },
      "rsiVerification": "RSI 验证",
      "settings": {
        "index": "设置",
        "profile": "档案",
        "account": "账户",
        "security": "安全",
        "notifications": "通知",
        "calendar": "日历",
        "donations": "捐赠",
        "hangar": "机库",
        "privacy": "隐私",
        "features": "功能",
        "connections": "连接",
        "oauthApplications": "OAuth 应用",
        "verify": "RSI 账户验证",
        "friends": "好友"
      },
      "reload": "有可用更新！",
      "visualTests": {
        "blueprints": "蓝图",
        "index": "视觉测试",
        "panels": "面板",
        "buttons": "按钮",
        "events": "活动",
        "typography": "排版",
        "forms": "表单",
        "tables": "表格",
        "lists": "列表",
        "metrics": "指标",
        "states": "状态",
        "notifications": "通知",
        "dedicationPlaques": "命名铭牌",
        "syncModal": "同步弹窗",
        "buybackSyncModal": "回购同步弹窗",
        "rsiVerificationModal": "RSI 验证弹窗",
        "fleetRsiVerificationModal": "舰队 RSI 验证弹窗",
        "overlays": "浮层",
        "installPrompt": "安装提示",
        "supportHint": "支持提示",
        "media": "媒体",
        "charts": "图表",
        "alerts": "提示",
        "verifiedBadges": "验证徽章",
        "chips": "Chips",
        "squadrons": "中队",
        "groups": {
          "foundations": "基础",
          "data": "数据",
          "feedback": "反馈",
          "features": "功能"
        },
        "notificationCenter": "通知中心",
        "themes": "主题"
      },
      "admin": {
        "features": {
          "overview": "概览",
          "users": "用户",
          "fleets": "舰队",
          "history": "历史"
        },
        "locations": {
          "index": "地点"
        },
        "blueprints": {
          "index": "蓝图"
        },
        "missions": {
          "index": "任务"
        },
        "index": "管理员",
        "models": {
          "index": "模型",
          "create": "创建模型",
          "edit": {
            "index": "基础数据",
            "metrics": "指标",
            "prices": "价格",
            "docks": "停靠点",
            "modules": "模块",
            "paints": "涂装",
            "images": "图片",
            "videos": "视频",
            "cargoAndFuel": "货物和燃料",
            "cargoHolds": "货舱",
            "fleetchart": "舰队图表图片",
            "positions": "岗位",
            "hardpoints": "挂载点",
            "loaners": "借用船",
            "snubCrafts": "微型舰载机",
            "upgrades": "升级",
            "packages": "套餐",
            "history": "历史"
          }
        },
        "modelPaints": {
          "index": "涂装",
          "create": "创建涂装"
        },
        "modelModules": {
          "index": "模块",
          "create": "创建模块",
          "edit": {
            "index": "基本数据",
            "models": "模型",
            "prices": "价格",
            "hardpoints": "武器挂点",
            "docks": "停靠点",
            "cargoHolds": "货舱",
            "history": "历史"
          }
        },
        "unlistedModels": {
          "index": "未收录的飞船"
        },
        "modelModulePackages": {
          "index": "模块包",
          "create": "创建模块包"
        },
        "components": {
          "index": "组件",
          "edit": {
            "index": "基础数据",
            "prices": "价格",
            "history": "历史"
          }
        },
        "manufacturers": {
          "index": "制造商",
          "edit": {
            "index": "基础数据",
            "models": "飞船",
            "components": "组件",
            "equipment": "装备",
            "modules": "模块"
          }
        },
        "images": {
          "index": "图片"
        },
        "users": {
          "index": "用户",
          "edit": "编辑",
          "fleets": "舰队",
          "inventories": "库存",
          "supporterContributions": "贡献"
        },
        "fleets": {
          "index": "舰队",
          "edit": "编辑",
          "members": "成员",
          "history": "历史",
          "roles": "角色",
          "inventories": "库存"
        },
        "fleetFidClaims": {
          "index": "FID 申领"
        },
        "destroyedFleets": {
          "index": "已删除舰队"
        },
        "vehicles": {
          "index": "载具"
        },
        "admins": {
          "index": "管理员"
        },
        "oauthApplications": {
          "index": "OAuth 应用"
        },
        "maintenance": {
          "index": "维护",
          "pghero": "PG-Hero",
          "features": "功能",
          "workers": "工作进程",
          "tasks": "任务",
          "imports": "导入",
          "rsiApiStatus": "RSI API 状态",
          "buildCompare": "版本对比"
        },
        "announcements": {
          "index": "公告",
          "new": "新建公告",
          "edit": "编辑公告"
        },
        "supporterContributions": {
          "index": "支持者贡献",
          "new": "新建支持者贡献",
          "edit": "编辑支持者贡献"
        },
        "fundingGoals": {
          "index": "资金目标",
          "new": "新建资金目标",
          "edit": "编辑资金目标"
        },
        "homepage": "首页",
        "gameEvents": {
          "index": "游戏活动",
          "new": "新建游戏活动",
          "edit": "编辑游戏活动"
        },
        "notifications": {
          "index": "通知"
        },
        "commodities": {
          "index": "Commodities",
          "edit": {
            "index": "Base Data"
          }
        },
        "equipment": {
          "index": "Equipment",
          "edit": {
            "index": "Base Data",
            "prices": "Prices"
          }
        },
        "visualTests": {
          "index": "视觉测试",
          "notifications": "通知"
        },
        "groups": {
          "catalogue": "目录",
          "community": "社区",
          "people": "人员",
          "system": "系统"
        }
      },
      "notifications": "通知",
      "scDataSource": "数据来源",
      "commodities": {
        "index": "商品"
      },
      "components": {
        "index": "部件"
      },
      "catalogue": {
        "commodities": "商品",
        "index": "目录",
        "components": "部件",
        "blueprints": "蓝图",
        "missions": "任务",
        "equipment": "装备"
      },
      "equipment": {
        "index": "装备"
      },
      "switcher": {
        "label": "在你的机库和舰队之间切换",
        "personal": "个人",
        "yourFleets": "你的舰队",
        "fleetDirectory": "舰队目录",
        "switch": "切换"
      },
      "account": {
        "menu": "账户菜单",
        "unread": "%{count} 条未读"
      }
    }
  }
}
